import React from 'react';
import PropTypes from 'prop-types';

import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import { reduxForm } from 'redux-form';

import Dialog from 'infrastructure/js/components/Dialog/dialog';

class DeleteDemoOrganizationDialog extends React.PureComponent {
  constructor(props) {
    super(props);

    this.dialogLabels = createLabelHelper('mat.dialog.');
    this.labels = createLabelHelper('mat.administration.dialog.deleteDemoOrganization.');

    this.deletionData = this.props.sData.get('deletionData').toJS(); //organizations data
  }

  getDialogButtons() {
    return {
      left: [
        {
          id: 'cancel',
          text: this.dialogLabels.get('cancel'),
          action: this.props.actions.hide,
        },
      ],
      right: [
        {
          id: 'submit',
          text: this.labels.get('footer.delete'),
          bsStyle: 'primary',
          loading: this.props.sData.get('loading'),
          action: this.props.handleSubmit(this.onSubmit),
          disabled: this.props.sData.get('loading'),
        },
      ],
    };
  }

  onSubmit = () => {
    const orgIds = this.deletionData.map(({id}) => id)
    this.props.actions.submit(orgIds, this.props.reloadParentComponent);
  };

  onHide = () => {
    this.props.actions.hide();
  };

  getBodyText = () => {
    const orgNames = this.deletionData.map(({name}) => name);
    return this.labels.get('body.text', '', { orgNames: orgNames.join(', '), count: orgNames.length });
  }

  render() {
    let titleText = this.labels.get('header.title');

    return (
      <Dialog
        id="delete-organization-dialog"
        className="delete-organization-dialog"
        titleText={titleText}
        show={this.props.sData.get('show')}
        onEntered={this.onEntered}
        onHide={this.onHide}
        sData={this.props.sData}
        footerButtons={this.getDialogButtons()}
      >
        <div className="delete-confirmation">{this.getBodyText()}</div>
      </Dialog>
    );
  }
}

export default reduxForm({
  form: 'deleteDemoOrganizationDialog',
})(DeleteDemoOrganizationDialog);

DeleteDemoOrganizationDialog.defaultProps = {};
DeleteDemoOrganizationDialog.propTypes = {
  actions: PropTypes.object.isRequired,
  sData: PropTypes.object.isRequired,
};
